const LOCAL_API_BASE_URL = 'http://localhost:8500';
const DEV_API_BASE_URL = 'https://dev.brandrecallai.com';
const PROD_API_BASE_URL = 'https://api.brandrecallai.com';

const normalizeBaseUrl = (value: string): string => value.replace(/\/+$/, '');

const isLocalHostname = (host: string): boolean =>
  host === 'localhost' || host === '127.0.0.1';

export const getApiBaseUrl = (): string => {
  const envBaseUrl = process.env.REACT_APP_API_URL?.trim();
  const host = typeof window !== 'undefined' ? window.location.hostname : '';

  // Guard against a localhost URL being baked into a deployed bundle (this
  // happens if the build runs with .env.local on disk). When the page is
  // clearly not on localhost, ignore the localhost env value and fall back
  // to a hostname-based default.
  if (envBaseUrl) {
    const envIsLocal = /^https?:\/\/(localhost|127\.0\.0\.1)(:|\/|$)/i.test(envBaseUrl);
    if (envIsLocal && host && !isLocalHostname(host)) {
      const fallback = host.endsWith('brandrecallai.com') && !host.startsWith('dev.')
        ? PROD_API_BASE_URL
        : DEV_API_BASE_URL;
      // eslint-disable-next-line no-console
      console.warn(
        `[apiBaseUrl] Ignoring REACT_APP_API_URL="${envBaseUrl}" on host "${host}". ` +
          `Falling back to "${fallback}". Rebuild with the correct REACT_APP_API_URL.`
      );
      return fallback;
    }
    return normalizeBaseUrl(envBaseUrl);
  }

  if (host && isLocalHostname(host)) {
    return LOCAL_API_BASE_URL;
  }

  if (host.endsWith('brandrecallai.com') && !host.startsWith('dev.')) {
    return PROD_API_BASE_URL;
  }

  return DEV_API_BASE_URL;
};

export const API_BASE_URL = getApiBaseUrl();
